"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchUntilExhausted = fetchUntilExhausted;
exports.processResponse = processResponse;

require("core-js/modules/es.array.sort.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.splice.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.match.js");

require("core-js/modules/es.array.concat.js");

var _union = _interopRequireDefault(require("lodash/union"));

var _utils = require("./utils");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Process raw API response
 * @param  {Object[]} response - The raw API response
 * @param  {Object} config     - Global ZoteroPublications config
 * @return {Object[]}          - Processed API response
 */
function processResponse(response) {
  if (response) {
    var childItems = [];
    var index = {};

    var _loop = function _loop(i) {
      var item = response[i];

      if (item.data && item.data.abstractNote) {
        item.data[_constants.ABSTRACT_NOTE_PROCESSED] = (0, _utils.formatAbstract)(item.data.abstractNote);
      }

      if (item.data && item.data.creators) {
        item.data[_constants.AUTHORS_SYMBOL] = {};
        item.data.creators.forEach(function (author) {
          var name = author.firstName && author.lastName ? author.firstName + ' ' + author.lastName : author.name;
          var type = author.creatorType.charAt(0).toUpperCase() + author.creatorType.slice(1);

          if (!item.data[_constants.AUTHORS_SYMBOL][type]) {
            item.data[_constants.AUTHORS_SYMBOL][type] = [];
          }

          item.data[_constants.AUTHORS_SYMBOL][type].push(name);
        });
      }

      if (item.data && item.meta.parsedDate) {
        item.data[_constants.FORMATTED_DATE_SYMBOL] = (0, _utils.formatDate)(item.meta.parsedDate);
      }

      if (item.data && item.data.parentItem) {
        response.splice(i, 1);
        childItems.push(item);
      }

      index[item.key] = item;
    };

    for (var i = response.length; i--;) {
      _loop(i);
    }

    for (var _i = 0, _childItems = childItems; _i < _childItems.length; _i++) {
      var item = _childItems[_i];

      if (!(item.data.parentItem in index)) {
        continue;
      }

      if (item.data.itemType === 'note') {
        if (!index[item.data.parentItem][_constants.CHILD_NOTES]) {
          index[item.data.parentItem][_constants.CHILD_NOTES] = [];
        }

        index[item.data.parentItem][_constants.CHILD_NOTES].push(item);
      } else if (item.data.itemType === 'attachment') {
        if (!index[item.data.parentItem][_constants.CHILD_ATTACHMENTS]) {
          index[item.data.parentItem][_constants.CHILD_ATTACHMENTS] = [];
        }

        var parsedAttachment = {};

        if (item.links && item.links.enclosure) {
          parsedAttachment = {
            url: item.links.enclosure.href || item.data.url,
            type: item.links.enclosure.type || item.data.contentType,
            title: item.links.enclosure.title || item.data.title,
            key: item.key,
            item: item
          };
        } else {
          parsedAttachment = {
            url: item.data.url,
            type: item.data.contentType,
            title: item.data.title,
            key: item.key,
            item: item
          };
        }

        if (parsedAttachment.title || parsedAttachment.url) {
          index[item.data.parentItem][_constants.CHILD_ATTACHMENTS].push(parsedAttachment);
        }
      } else {
        if (!index[item.data.parentItem][_constants.CHILD_OTHER]) {
          index[item.data.parentItem][_constants.CHILD_OTHER] = [];
        }

        index[item.data.parentItem][_constants.CHILD_OTHER].push(item);
      }
    }

    for (var _i2 = response.length; _i2--;) {
      var _item = response[_i2];

      if (_item[_constants.CHILD_ATTACHMENTS]) {
        _item[_constants.CHILD_ATTACHMENTS].sort(function (a, b) {
          return new Date(a.item.data.dateAdded).getTime() - new Date(b.item.data.dateAdded).getTime();
        });
      }

      if (_item[_constants.CHILD_ATTACHMENTS]) {
        _item[_constants.VIEW_ONLINE_URL] = _item[_constants.CHILD_ATTACHMENTS][0].url;

        if (_item[_constants.CHILD_ATTACHMENTS][0].type === 'application/pdf') {
          _item[_constants.HAS_PDF] = true;
        }
      } else if (_item.data && _item.data.url) {
        _item[_constants.VIEW_ONLINE_URL] = _item.data.url;
      }
    }
  }

  return response;
}
/**
 * Recursively fetch data until there's no more rel="next" url in Link header
 * @param  {String} url             - An url for initial data request
 * @param  {Object} [options]       - Custom settings (e.g. headers) passed over to fetch() for each request
 * @param  {Object[]} [jsondata=[]] - Used for data aggregation in recursive calls
 * @return {Promise}                - Resolved with complete dataset or rejected on error
 */


function fetchUntilExhausted(url, options, jsondata) {
  var relRegex = /<(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*))>;\s*rel="next"/;
  jsondata = jsondata || [];
  return new Promise(function (resolve, reject) {
    fetch(url, options).then(function (response) {
      if (response.status >= 200 && response.status < 300) {
        response.json().then(function (jsonDataPart) {
          if (!(jsonDataPart instanceof Array)) {
            jsonDataPart = [jsonDataPart];
          }

          if (response.headers.has('Link')) {
            var matches = response.headers.get('Link').match(relRegex);

            if (matches && matches.length >= 2) {
              resolve(fetchUntilExhausted(matches[1], options, (0, _union.default)(jsondata, jsonDataPart)));
            } else {
              resolve((0, _union.default)(jsondata, jsonDataPart));
            }
          } else {
            resolve((0, _union.default)(jsondata, jsonDataPart));
          }
        }).catch(function (e) {
          reject(new Error("Unparsable JSON when requesting ".concat(url, ": ").concat(e)));
        });
      } else {
        reject(new Error("Unexpected status code ".concat(response.status, " when requesting ").concat(url)));
      }
    }).catch(function () {
      reject(new Error("Unexpected error when requesting ".concat(url)));
    });
  });
}